export const HELIX_TYPE_LIST = 'list';

export const findAncestorWithHelixType = (element: HTMLElement, helixType: string): HTMLElement => {
    if (!element || !helixType) {
        return null;
    }

    let parent = element;
    while (parent && parent.getAttribute('data-helix-type') !== helixType) {
        parent = parent.parentElement;
    }

    return parent;
};

export function getListIndex(list: HTMLElement): number {
    const lists = document.querySelectorAll(`[data-helix-type="${HELIX_TYPE_LIST}"]`);

    let listIndex = Array.from(lists).indexOf(list);
    listIndex = listIndex > -1 ? listIndex + 1 : -1;

    return listIndex;
}
